var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCross(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M8.00004 0C5.87928 0.00299794 3.84604 0.848916 2.34636 2.35258C0.846672 3.85624 0.00301927 5.89483 0 8.02126C0.439027 18.6615 15.5611 18.6577 16 8.02126C15.997 5.89488 15.1533 3.85624 13.6536 2.35258C12.154 0.848916 10.1208 0.00302728 7.99996 0H8.00004ZM11.8326 11.073C12.0376 11.2935 12.0314 11.6371 11.819 11.8503C11.6064 12.0633 11.2636 12.0695 11.0437 11.864L8.00007 8.8122L4.95639 11.864C4.73646 12.0695 4.39379 12.0633 4.18116 11.8503C3.96871 11.6371 3.96256 11.2935 4.16754 11.073L7.21122 8.02126L4.16754 4.96951C4.05674 4.86591 3.99263 4.72168 3.98997 4.56995C3.98731 4.41805 4.04628 4.27165 4.15342 4.16439C4.2604 4.05696 4.40641 3.99784 4.55791 4.0005C4.70924 4.00316 4.85309 4.06745 4.95641 4.17855L8.00009 7.2303L11.0438 4.17855C11.2637 3.97302 11.6064 3.97918 11.819 4.1922C12.0315 4.40539 12.0376 4.74901 11.8326 4.96949L8.78894 8.02124L11.8326 11.073Z",
    fill: "#F2484B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCross);
export default __webpack_public_path__ + "static/media/cross.937791a87df520ebf0633fbcf471308e.svg";
export { ForwardRef as ReactComponent };